<template>
<div class="chapter">
<div class="inner_page">
<p class="partnum"><i>Part I</i></p>
<p class="parttit">ANSWERING THE CALL: THOSE WHO VOLUNTEERED</p>
<p class="center"><i>I appeal to all loyal citizens to favor, facilitate, and aid this effort to maintain the honor, the integrity, and the existence of our National Union, and the perpetuity of popular government</i>.</p>
<p class="center"><i>—President Abraham Lincoln, A Proclamation, April 15, 1861</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?50d00874